import "./styles.css";

export function Title() {
  return (
    <div className="title">
      <h2>DIVINA ORDEM MíSTICA</h2>
      <p>A grande sabedoria é entender o planejado no etéreo</p>
    </div>
  );
}
